module.exports = __webpack_public_path__ + "static/media/out_point_charge.739cd31f.svg";